export default __webpack_public_path__ + "static/media/Results.b74f7c41.svg";